module.exports = __webpack_public_path__ + "static/media/icon_person_add.26599b0d.svg";